import { useEffect, useRef, useState } from "react";

import { useTimeoutRef } from "@hooks/useTimeoutRef";

import "./Transition.css";

type Props = {
  children: React.ReactNode;
  screenKey: string | number;
  disableTransition?: boolean;
};

export const TransitionWrapper = ({ children, screenKey, disableTransition }: Props) => {
  const [current, setCurrent] = useState(children);
  const [fadeState, setFadeState] = useState<"slide-in" | "slide-out" | "">("slide-in");
  const prevKeyRef = useRef(screenKey);
  const { schedule: scheduleFadeIn, clear: clearFadeIn } = useTimeoutRef();

  useEffect(() => {
    if (screenKey !== prevKeyRef.current) {
      // if disableTransition === true than change screen instantly
      if (disableTransition) {
        prevKeyRef.current = screenKey;
        setCurrent(children);
        setFadeState("");
        return;
      }

      // start fade-out of old screen
      setFadeState("slide-out");

      // after 300ms change content and start fade-in
      scheduleFadeIn(() => {
        prevKeyRef.current = screenKey;
        setCurrent(children);
        setFadeState("slide-in");
      }, 300); // should match with CSS styles

      // Reset to slide-in if interrupted
      return () => {
        clearFadeIn();
        setFadeState("slide-in");
      };
    } else {
      setCurrent(children);
    }
  }, [screenKey, children, scheduleFadeIn, clearFadeIn]);

  return <div className={`transition-wrapper ${fadeState}`}>{current}</div>;
};
